import { Component, ViewChild, Renderer2, ElementRef } from '@angular/core';
import { AlertController, App } from 'ionic-angular';

import { DomSanitizer } from '@angular/platform-browser';

import { IdomooProvider } from '../../providers/idomoo/idomoo';
import { EvtProvider } from '../../providers/evt/evt';

/**
 * Generated class for the VideoPreviewComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'video-preview',
  templateUrl: 'video-preview.html'
})
export class VideoPreviewComponent {

  text: string;
  assets: Array<any> = [];
  expanded: boolean = false;
  generated: boolean = false;
  downloaded: boolean = false;
  played: boolean = false;
  playing: boolean = false;
  photoHistory : any = [];
  platformer : boolean = true;
  @ViewChild('plyr') plyr : ElementRef;
  @ViewChild('dlLink') dlLink : ElementRef;
  @ViewChild('xpand') xpand : ElementRef;//{{assets?.vid}}

  constructor(public idomoo: IdomooProvider, public render: Renderer2, private sanitizer: DomSanitizer, private evt: EvtProvider, private alert:AlertController, private app: App) {
    if(navigator.platform == "iPhone"){
      this.platformer = false;
    }
  }

  ngAfterViewInit(){
    this.assets['arr'] = "../assets/images/down-arrow.png";
    this.assets['link'] = this.sanitizer.bypassSecurityTrustResourceUrl("../assets/images/Selflove.jpg");
    //console.log(this.plyr.nativeElement.innerHTML);
    this.photoHistory = eval(localStorage.cygHistory || []).slice(-30)[0];
  }

  toggleView(){
  	let self = this;
  	this.expanded = !this.expanded;
  	if(this.expanded){
  		this.idomoo.generateVid().then(res=>{
    		self.assets['link'] = this.sanitizer.bypassSecurityTrustResourceUrl(localStorage.vid);
        self.assets['vid'] = "";
        console.log(res);
		  }).catch(err=>{
        let alertr = this.alert.create({
          title: '',
          enableBackdropDismiss: true,
          cssClass: 'custom-modal',
          message: `<p>It looks like that didn't work. Please try again later.</p>`,
          buttons: [
            {
              text:"",
              role:"cancel"
            }
          ]
        });
        alertr.present();
        self.unloadIdomooPlyr();
        self.expanded = false;
      });
  	}
    else{
      this.unloadIdomooPlyr();
    }
  }

  perf($event){
    console.log(navigator.platform);
    let self = this;
    this.evt.createThngAction('_DownloadVideo');  
    self.assets['vid'] = self.sanitizer.bypassSecurityTrustUrl(localStorage.vid);
    setTimeout(()=>{
      this.downloaded = true;
      if(navigator.platform == "iPhone"){
        self.render.removeAttribute(self.dlLink.nativeElement,"download");
        //self.render.setProperty(self.dlLink.nativeElement,"target","_blank");
        self.dlLink.nativeElement.click();
        //self.app.getActiveNavs()[0].setRoot("IdomooPlayerPage");
      }else{
        self.dlLink.nativeElement.click();
      }
    },2000);
  }

  playStatus($event){
    if(!this.played){
      this.evt.createThngAction('_PreviewVideo');
      this.played = true;
    }
  }

  unloadIdomooPlyr(){
    let pv : HTMLVideoElement = <HTMLVideoElement> document.getElementById('idm');
    this.downloaded = false;
    this.playing = false;
    this.played = false;
    pv.pause();
    pv.currentTime = 0;
  }

  resetPlayer(){
  	//this.render.setProperty(this.plyr.nativeElement,'innerHTML',"");
  	this.assets['link'] = this.sanitizer.bypassSecurityTrustResourceUrl("../assets/images/Selflove.jpg");
  }

  DL(){
    this.downloaded = true;
  	this.evt.createThngAction('_DownloadVideo');	
  }

  playMe($event){
    let pv : HTMLVideoElement = <HTMLVideoElement> document.getElementById('idm');
    this.playing = true;
    setTimeout(()=>{
      pv.play();
      console.log('Now playing');
    },500);

  }

}



// WEBPACK FOOTER //
// ./src/components/video-preview/video-preview.ts